module.exports = __webpack_public_path__ + "img/python.146716bd.svg";